import PageBanner from "../../../../src/components/PageBanner";
import * as React from 'react';
export default {
  PageBanner,
  React
};